import { create } from 'zustand';

type IsViewType = 'isView';
type IsAppType = 'isApp';

interface ModalState {
  isView: boolean;
  isApp: boolean;
  mainTapIndex: number;

  actions: {
    changeModalState: (type: IsViewType) => void;
    changeIsAppState: (type: IsAppType) => void;
    changeMainTabIndex: (index: number) => void;
  };
}

const useModalStore = create<ModalState>((set) => ({
  isView: false,
  isApp: false,
  mainTapIndex: 0,
  actions: {
    changeModalState: (type) => {
      set((state) => ({ ...state, [type]: !state[type] }));
    },
    changeIsAppState: (type) => {
      set((state) => ({ ...state, [type]: true }));
    },
    changeMainTabIndex: (index) => {
      set({ mainTapIndex: index });
    }
  },
}));

export default useModalStore;

export const useModalActions = () => useModalStore((state) => state.actions);
export const useNicknameModalState = () => useModalStore((state) => state.isView);
export const useIsAppState = () => useModalStore((state) => state.isApp);
export const useMainTabIndex = () => useModalStore((state) => state.mainTapIndex);